import { MainApi } from "./MainApi";
import { EventTesterPostParam } from "../types/event";

export class EventApi {
  static baseUrl = `${MainApi.urlPrefix}/user/two-thousand-test`;

  static postTester = (param: EventTesterPostParam) => () => MainApi.api.post(`${EventApi.baseUrl}`, param);
}
